import { render, staticRenderFns } from "./DateTimeView.vue?vue&type=template&id=3796b65f&scoped=true&"
import script from "./DateTimeView.vue?vue&type=script&lang=js&"
export * from "./DateTimeView.vue?vue&type=script&lang=js&"
import style0 from "./DateTimeView.vue?vue&type=style&index=0&id=3796b65f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3796b65f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
